import { render, staticRenderFns } from "./addPrizeDetails.vue?vue&type=template&id=a673b2fe&scoped=true&"
import script from "./addPrizeDetails.vue?vue&type=script&lang=ts&"
export * from "./addPrizeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./addPrizeDetails.vue?vue&type=style&index=0&id=a673b2fe&lang=scss&scoped=true&"
import style1 from "./addPrizeDetails.vue?vue&type=style&index=1&id=a673b2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a673b2fe",
  null
  
)

export default component.exports